import { Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MenuItem, TextField, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext, useEffect, useState } from "react"
import { useHistory } from 'react-router-dom'
import SharedUtilities from '../../shared/classes/SharedUtilities'
import Utilities from '../classes/Utilities'
import GuestForm from '../components/GuestForm'
import { AppContext } from '../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    marginAbove: {
        marginTop: theme.spacing(3),
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}))

export default function LeadForm(props) {
    const { paths, showMessage, showError, socket, embedOptions, user, userType, messageCompanion } = useContext(AppContext)
    const history = useHistory()
    const [waiting, setWaiting] = useState(false)
    const [complete, setComplete] = useState(false)
    const [bookLead, setBookLead] = useState(false)
    const [leadFormData, setLeadFormData] = useState(false)
    const classes = useStyles()
    const caregiverParam = SharedUtilities.getUrlParam('caregiver')

    // request data on-mount
    useEffect(() => {
        socket
            .send('leadForm', { step: 'getData', caregiverParam })
            .then(setLeadFormData)
            .catch(showError)
    }, [setLeadFormData])

    async function handleSubmit(event) {
        event.preventDefault()

        setWaiting(true)

        try {
            const leadInfo = Utilities.getFormValues(event.target)

            const response = await socket.send('leadForm', {
                step: 'submitLeadData',
                leadInfo,
                caregiverParam,
            })

            setComplete(true)
            showMessage(response, { variant: 'success' })

            // ask if we want to book the lead
            if (caregiverParam) {
                setBookLead(leadInfo)

            } else if (embedOptions.leadLandingUrl) {
                messageCompanion({
                    navigateAway: embedOptions.leadLandingUrl,
                })
            }

        } catch (err) {
            showError(err)
            setWaiting(false)
        }
    }

    async function handleBook(leadInfo) {
        try {
            setBookLead(false)

            if (userType == 'caregiver') {
                const { remoteUsers } = await socket.send('remoteUsers', {
                    step: 'getRemoteUsers',
                })

                const remoteUser = remoteUsers.find(user => user.email_address == leadInfo.email)

                if (remoteUser) {
                    await socket.send('remoteUsers', {
                        step: 'setRemoteUser',
                        remoteUser,
                    })
                }

                let url = paths.book

                if (leadFormData.caregiverProgram == 'MDVIP') {
                    url += `/findByAbbrev/MDVIP-DC`
                }

                history.push(url)

            } else {
                let url = `${paths.root}/guest${paths.book.replace(paths.root, '')}`

                if (leadFormData.caregiverProgram == 'MDVIP') {
                    url += `/findByAbbrev/MDVIP-DC`
                }

                history.push(`${url}?guestInfo=${encodeURIComponent(JSON.stringify(leadInfo))}&skipGuestInfo=true`)
            }

        } catch (err) {
            showError(err)
        }
    }

    let optionals
    let showCampaignTypes
    let caregiverBookNowMsg

    // MDVIP customizations
    if (leadFormData.caregiverProgram == 'MDVIP') {
        optionals = ['street1', 'street2', 'city', 'state', 'zip']
        showCampaignTypes = false
        caregiverBookNowMsg = 'Would you like to book the discovery call with this patient now?'
    } else {
        optionals = embedOptions.leadFormOptionals?.split(',').map(field => field.trim())
        showCampaignTypes = leadFormData.campaignTypes?.length > 0
        caregiverBookNowMsg = 'Would you like to book an appointment for this patient now?'
    }

    return (
        <Container maxWidth="xs">
            {!complete &&
                <GuestForm
                    className={classes.marginAbove}
                    optionals={optionals}
                    onSubmit={handleSubmit}
                >
                    {showCampaignTypes &&
                        <Grid item xs={12}>
                            <TextField
                                select={true}
                                id="campaignType"
                                name="campaignType"
                                label="How did you hear about us?"
                                variant="outlined"
                                autoComplete="campaignType"
                                fullWidth
                                defaultValue=""
                            >
                                {leadFormData.campaignTypes?.map(campaignType => (
                                    <MenuItem key={campaignType.name} value={campaignType.name}>{campaignType.name}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <TextField
                            id="note"
                            name="note"
                            label="Is there anything else you would like us to know?"
                            variant="outlined"
                            autoComplete="off"
                            multiline
                            minRows={4}
                            fullWidth
                        />
                    </Grid>
                    <Grid item container justifyContent="flex-end">
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={waiting}
                        >
                            Submit
                        </Button>
                    </Grid>
                </GuestForm>
            }
            {complete &&
                <form className={classes.form}>
                    <Grid container spacing={2}>
                        <Typography>
                            Your information has been submitted. Thank you!
                        </Typography>
                    </Grid>
                </form>
            }
            <Dialog
                open={!!bookLead}
                onClose={() => { setBookLead(false) }}
            >
                <DialogTitle>Book Appointment?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {userType == 'caregiver' ? caregiverBookNowMsg : 'Would you like to book an appointment now?' }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        autoFocus
                        onClick={() => { handleBook(bookLead) }}
                    >
                        Yes
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => { setBookLead(false) }}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    )
}
